import { format, subDays } from 'date-fns';
import { useMemo } from 'react';

import { useCurrentUser } from '@bonusly/who-am-i';

import { useLeaderboard } from '../../../modules/bonus-feed/features/recognition/api/hooks/leaderboards';
import { partnerNameFromPageName, pickExamplePartnerFirstName } from '../lib/prompt-library-partner-name';

/** Example name for prompt library {{name}} — leaderboard off 1:1 pages, page title on 1:1. */
export function usePromptLibraryPartnerName(pageType: string | undefined, pageName?: string): string | undefined {
	const user = useCurrentUser();
	const leaderboardFilters = useMemo(
		() => ({
			direction: 'received' as const,
			start_date: format(subDays(new Date(), 30), 'yyyy-MM-dd'),
			end_date: format(new Date(), 'yyyy-MM-dd'),
			limit: 5,
		}),
		[]
	);
	const { data: leaderboard } = useLeaderboard(leaderboardFilters);

	return useMemo(() => {
		if (pageType === '1on1') return partnerNameFromPageName(pageName);

		return pickExamplePartnerFirstName(leaderboard?.users ?? [], user.id);
	}, [leaderboard?.users, pageName, pageType, user.id]);
}
